import { initialAppState } from '../appSlice';

export function getPreLoadedState() {
	if (typeof window === 'undefined') return { app: initialAppState, sections: [] };
	const savedState = JSON.parse(localStorage?.getItem('applicationState') || '{}');

	const state = {
		app: {
			...initialAppState,
			bpm: savedState?.app?.bpm || 120,
			timeSignature: savedState?.app?.timeSignature || [4, 4]
		},
		sections: savedState?.sections || []
	};

	return state;
}
